export const getPrimaryContact = (data) => {
    return data.contacts?.find((item) => item.primaryContact);
};
/**
 * Gets the primary contact from a customer or returns the first contact if there is no primary contact
 */
export const getPrimaryCustomerContact = (data) => {
    return data.contacts?.find((item) => item.primaryContact) || data.contacts[0];
};
//# sourceMappingURL=get-primary-contact.js.map